export function Footer() {
    return (
        <footer className="site-footer no-print">
            <div className="footer-divider">
                <hr />
            </div>
            
            <div className="footer-content">
                <div className="footer-mobile">
                    <p className="footer-copyright">
                        &copy; 2026 <a href="https://theaamgroup.com/" target="_blank" rel="noopener noreferrer">AAM USA, Inc.</a> All rights reserved.
                    </p>
                </div>

                <div className="footer-desktop">
                    <div className="footer-links">
                        <a href="http://theaamgroup.com/contact" target="_blank" rel="noopener noreferrer">Contact Us</a>
                        <span className="footer-separator">|</span>
                        <a href="http://theaamgroup.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                        <span className="footer-separator">|</span>
                        <a href="http://theaamgroup.com/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>
                        <span className="footer-separator">|</span>
                        <a href="tel:8882514252">(888) 251-4252</a>
                    </div>
                    <p className="footer-copyright">
                        &copy; 2026 <a href="https://theaamgroup.com/" target="_blank" rel="noopener noreferrer">AAM USA, Inc.</a> All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
}
